<template>
  <span class="purchase-payment-method">
    <span class="icon"><ion-icon :name="icon"></ion-icon></span>
    {{ text }}
  </span>
</template>

<script>
const paymentMethod = {
  B: {
    icon: 'cash-outline',
    text: 'Boleto',
  },
  CC: {
    icon: 'card-outline',
    text: 'Cartão de Crédito',
  },
};

export default {
  name: 'PurchasePaymentMethod',

  props: {
    paymentMethod: {
      required: true,
      type: String,
    },
  },

  computed: {
    icon() {
      return paymentMethod[this.paymentMethod]
        ? paymentMethod[this.paymentMethod].icon
        : this.paymentMethod;
    },

    text() {
      return paymentMethod[this.paymentMethod]
        ? paymentMethod[this.paymentMethod].text
        : this.paymentMethod;
    },
  },
};
</script>

<style lang="scss" scoped>
  .purchase-payment-method {
    @apply text-secondary-500;

    > .icon {
      position: relative;
      top: 2px;
    }
  }
</style>
